import { defineStore } from "pinia";
import environment from "@/environment";
import Crud from "@/store/crud";
import CountryData from "@/store/country-data";
import { useLK } from "@/controllerLK/LKstore";
import { toTimestamp } from "@/tools/date-time-tools";

const crud = new Crud(
  environment.appConfig.baseApiUrl + "Analytics/rubrics/importance/by_day_of_week/:projectId",
  "id",
  "",
  {},
);
const countryData = new CountryData();

export const useImportanceByRubricStatBlocksStore = defineStore({
  id: "importanceByRubricStatBlocksStore",
  state: () => ({
    ...crud.state,
    ...countryData.state,
  }),
  getters: {
    ...crud.getters,
    ...countryData.getters,
  },
  actions: {
    ...crud.actions,
    ...countryData.actions,
    async loadStat(dateFrom, dateTo, body = [], isFirstRequest = false) {
      let params = {};
      if (dateFrom) {
        params = {
          dateStart: toTimestamp(dateFrom),
          dateEnd: toTimestamp(dateTo),
        };
      }

      if (!isFirstRequest && body.length === 0) {
        this.items = [];
        return false;
      }

      const lk = useLK();
      return await this.loadCountryData({
        countryCode: lk.project.id,
        clear: true,
        body,
        usePost: true,
        params,
      });
    },
  },
});
